import React from 'react';
import { Clock, Euro } from 'lucide-react';
import { Button } from '../components/ui/button';
import { spaServices } from '../mockData';

const Spa = () => {
  const spaFeatures = [
    {
      title: 'Finnische Sauna',
      description: 'Traditionelle Sauna für tiefe Entspannung und Entgiftung des Körpers',
      image: '/images/sauna.jpg'
    },
    {
      title: 'Infrarot Kabine',
      description: 'Sanfte Wärme zur Muskelregeneration und Stressabbau',
      image: '/images/infrarot.jpg'
    },
    {
      title: 'Solarium',
      description: 'Moderne Bräunungstechnologie für gesunde und gleichmäßige Bräune',
      image: '/images/solarium.jpg'
    }
  ];

  return (
    <div className="bg-black min-h-screen pt-20">
      {/* Hero */}
      <section className="relative h-[70vh] flex items-center justify-center text-white">
        <div className="absolute inset-0">
          <img 
            src="/images/spa-header-image.jpg"
            alt="Spa"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-6 uppercase">
            Spa & Wellness
          </h1>
          <p className="text-xl text-white/90 mb-8">
            Entspannen. Regenerieren. Ihr exklusiver Wellness-Bereich für Erholung und Wohlbefinden.
          </p>
        </div>
      </section>

      {/* Spa Philosophy */}
      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold mb-8 text-black">
                Ihr Wellness-Bereich
              </h2>
              <p className="text-lg text-black/80 mb-6 leading-relaxed">
                Der POSITIV Spa-Bereich steht allen Mitgliedern zur Verfügung und bietet die perfekte Ergänzung zu Ihrem Training. Nutzen Sie unsere modernen Wellness-Einrichtungen zur Regeneration und Entspannung.
              </p>
              <p className="text-lg text-black/80 mb-8 leading-relaxed">
                Von der finnischen Sauna über die Infrarot-Kabine bis zum Solarium – alles steht Ihnen als Mitglied kostenlos zur Verfügung. Genießen Sie die wohltuende Wirkung nach jedem Training.
              </p>
              <Button size="lg" className="bg-black text-white hover:bg-black/90 h-12 px-8">
                Mitglied werden
              </Button>
            </div>
            <div className="relative aspect-[4/3]">
              <img 
                src="/images/spa-reg.jpg"
                alt="Spa Philosophy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Amenities */}
      <section className="bg-black py-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="relative aspect-[4/3]">
              <img 
                src="/images/spa-arg.jpg"
                alt="Amenities"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-white">
              <h2 className="text-4xl lg:text-5xl font-bold mb-8">
                Wellness-Ausstattung
              </h2>
              <p className="text-lg text-white/80 mb-6 leading-relaxed">
                Als Mitglied haben Sie unbegrenzten Zugang zu unserem kompletten Spa-Bereich:
              </p>
              <ul className="space-y-4 text-white/80">
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-white mt-2 flex-shrink-0" />
                  <span>Finnische Sauna für tiefe Entspannung</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-white mt-2 flex-shrink-0" />
                  <span>Infrarot-Kabine zur Muskelregeneration</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-white mt-2 flex-shrink-0" />
                  <span>Solarium mit moderner Technologie</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-white mt-2 flex-shrink-0" />
                  <span>Ruheräume mit entspannender Atmosphäre</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-2 h-2 rounded-full bg-white mt-2 flex-shrink-0" />
                  <span>Premium Handtücher und Pflegeprodukte</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Spa Features */}
      <section className="bg-white py-24">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-black">
              Unsere Wellness-Bereiche
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {spaFeatures.map((feature, index) => (
              <div key={index} className="group relative overflow-hidden aspect-[3/4]">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                  <h3 className="text-2xl font-bold mb-3">{feature.title}</h3>
                  <p className="text-white/80 text-sm leading-relaxed">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-white py-24">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-black">
            Bereit für Ihre Wellness-Auszeit?
          </h2>
          <p className="text-xl text-black/70 mb-8">
            Werden Sie Mitglied und nutzen Sie unseren exklusiven Spa-Bereich nach jedem Training.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Spa;
